<div class="fullsize-vbox" style="flex: 1; overflow: auto; border: 1px solid #ccc;">
    <wj-tree-view #theTree [itemsSource]="rootArray" (initialized)="onTreeViewInitialized(theTree)"
                  displayMemberPath="name" childItemsPath="children"
                  [isReadOnly]=false [autoCollapse]="false"
                  [showCheckboxes]="false"
                  [allowDragging]="true" [allowMultiSelect]="false"
                  (selectedNodeChange)="onSelectedNodeChange(theTree, $event)"
                  (nodeEditEnded)="onNodeEditEnded(theTree, $event)"></wj-tree-view>
</div>
<div class="toolbar-horizontal">
    <fluent-button appearance="subtle" (click)="onAddFolder(theTree)" [disabled]="!selectedNode() || selectedNodeIsLeaf()">
        <i class="far fa-folder-plus"></i>
    </fluent-button>

    <fluent-button appearance="subtle" (click)="onRemoveItem()" [disabled]="!selectedNode() || selectedNodeIsRoot()">
        <i class="far fa-trash"></i>
    </fluent-button>

    <fluent-button appearance="subtle" (click)="onShareLink()" [disabled]="!selectedNodeIsLeaf()">
        <i class="far fa-share-nodes"></i>
    </fluent-button>

    @if(mode() === 'add') {
        <fluent-button [disabled]="!selectedTreeItem()" (click)="onAddHere()">Add Here</fluent-button>
    } @else {
        <fluent-button [disabled]="!selectedNodeIsLeaf()" (click)="onOpenView()">Open</fluent-button>
    }

</div>
